// Copyright (c) 2024 by Audere

import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
} from "./common";

export const cloverLabelingTypes = commonLabelingTypes;

const cloverLabelingTasks = commonLabelingTasks;

const cloverQuestions = commonQuestions;

export const cloverLabelingSchemaV1 = {
  labelingTypes: cloverLabelingTypes,
  labelingTasks: cloverLabelingTasks,
  labelingQuestions: cloverQuestions,
  labelingSchemaVersion: "cloverLabelingSchemaV1",
};
